import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import _ from "lodash";
import {organizationSettingsActions} from "_actions";

export default function useGetRemoveProcesses(organizationId) {
    const dispatch = useDispatch();

    useEffect(() => {
        if (!_.isEmpty(organizationId)) {
            dispatch(organizationSettingsActions.fetchOrganizationRemoveProcesses(organizationId));
        }
    }, [organizationId]);

    const organizationSettings = useSelector(state => state.organizationSettings);
    const loading = organizationSettings.loadingRemoveProcesses;
    const removeProcesses = organizationSettings.removeProcesses;

    return {removeProcesses, loading};
}
